/**
 * Created by Mark on 19/04/2017.
 */


/**
 * Created by Mark on 17/04/2017.
 */

import React  from 'react';
import Layout from '../components/layouts/standard-page.js';
import Card from '../components/card.js';
import CardBody from '../components/card-body.js';
import CardHead from '../components/card-header.js';
import { FormattedMessage } from 'react-intl';
import ClassesTable from '../components/tables/classes-table.js';
import ButtonGroup from 'react-bootstrap/lib/ButtonGroup'
import ButtonToolbar from 'react-bootstrap/lib/ButtonGroup'
import Button from 'react-bootstrap/lib/ButtonGroup'
import Row from 'react-bootstrap/lib/Row';
import { Link , hashHistory } from "react-router";
import {Breadcrumb} from "react-bootstrap"
import AuthneticationStore from "../store/authentication-store.js";

export default class ScoresComponent extends React.Component {

    constructor(props) {
        super();
        this.state = {
            open:true
        }
    }


    handelCreateClass(){
        hashHistory.push('/classes/wizard')
    }

    handelNewAssignment(){
        hashHistory.push('/assignment/wizard')
    }

    getBreadCrumb(){

        return  <Breadcrumb>
            <Breadcrumb.Item href="#/dashboard">
                <FormattedMessage id={ 'ui-779' } defaultMessage={ '' }/>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>
                <FormattedMessage id={ 'ui-782' } defaultMessage={ '' }/>
            </Breadcrumb.Item>
        </Breadcrumb>
    }

    render(){

        const additionalButtons = [];

        if(AuthneticationStore.hasCreatePermissions())
        {
            additionalButtons.push({icon:'zmdi zmdi-plus-circle zmdi-hc-fw' , text: <FormattedMessage id={ 'ui-421' } defaultMessage={ 'Create new class' }/>, action:this.handelCreateClass});
        }



        return (<Layout>
                {this.getBreadCrumb()}
                    <Card>
                        <CardHead>
                                <h2>
                                    <FormattedMessage id={ "ui-782" } defaultMessage={ "Class Management" }/>
                                </h2>
                        </CardHead>
                        <CardBody noPadding>
                            <ClassesTable additionalButtons={additionalButtons}/>
                        </CardBody>
                    </Card>
                </Layout>);
    }
}




// WEBPACK FOOTER //
// ./src/screens/class-management.js